import React, { FunctionComponent, useContext, useState } from 'react'

interface Filter {
  zone: number
  reservationType: number
  plateNumber: string
  client: string
  createdFrom: string
  createdTill: string
}

type RootState = {
  filter: Filter
  loadList: number
  listLoading: boolean
  listPerPage: number
  listPage: number
}

type RootFunctions = {
  setListLoading(status: boolean): void
  setListPage(value: number): void
  onFilter(filter: Filter): void
  onChangePerPage(perPage: number): void
  onChangePage(page: number): void
}

const InitialState: RootState = {
  filter: {
    zone: 0,
    reservationType: 0,
    plateNumber: '',
    client: '',
    createdFrom: '',
    createdTill: '',
  },
  loadList: 0,
  listLoading: false,
  listPerPage: 20,
  listPage: 1,
}

export const ReservationsContext = React.createContext<[RootState, (state: any) => void]>([InitialState, () => {
}])

export const ReservationsProvider: FunctionComponent = ({ children }) => {
  const [state, setState] = useState<RootState>(InitialState)

  return (
    <ReservationsContext.Provider value={[state, setState]}>
      {children}
    </ReservationsContext.Provider>
  )
}

export const useReservations = (): RootFunctions & RootState => {
  const [state, setState] = useContext(ReservationsContext)

  const setListLoading = (status: boolean) => {
    setState((state: RootState) => ({
      ...state,
      listLoading: status,
    }))
  }

  const setListPage = (value: number) => {
    setState((state: RootState) => ({
      ...state,
      listPage: value,
    }))
  }

  const onFilter = (filter: Filter) => {
    setState((state: RootState) => ({
      ...state,
      filter,
      loadList: state.loadList + 1,
      listPage: 1,
    }))
  }

  const onChangePerPage = (perPage: number) => {
    setState((state: RootState) => ({
      ...state,
      loadList: state.loadList + 1,
      listPerPage: perPage,
      listPage: 1,
    }))
  }

  const onChangePage = (page: number) => {
    setState((state: RootState) => ({
      ...state,
      loadList: state.loadList + 1,
      listPage: page,
    }))
  }

  return {
    setListLoading,
    setListPage,
    onFilter,
    onChangePerPage,
    onChangePage,
    ...state,
  }
}
